import React, { useEffect, useState } from 'react'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import VehicleTaxDebtView from './components/VehicleTaxDebtView'

const ScreeningQuestion = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('vehicle-tax-debt', 'Pay a Debt', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <VehicleTaxDebtView setIsError={setIsError} />
}

export default withTranslation('common')(ScreeningQuestion)
